import React from 'react';

import {Modal, ModalHeader, ModalBody } from 'Components/Partials/Modal';
import {Button } from 'Components/Partials/Form';
import Base from 'Components/Base/Base';

import AbsenceForm from '../Absence/AbsenceForm';

import Attendance from 'Services/Api/HumanResource/Attendance';

/**
 * @classdesc
 */
export default class MissingAttendance extends Base {
    /**
     * @var state
     */
    state = {
        working: false,
        sick: false,
    };

    /**
     * @method handleWasHere
     * @return {Promise<void>}
     */
    handleWasHere = async () => {
        this.working();

        const request = await Attendance.checkIn('last', {
            present: true
        });

        if (request.status !== 201 && request.status !== 200) {
            this.toastError('Sorry, there was a problem processing your check in');
            return;
        }

        this.toastSuccess('Your attendance has been registered!');
        this.props.onClose();
    };

    /**
     * @method handleToggleWasSick
     */
    handleToggleWasSick = () => this.setState({
        sick: !this.state.sick,
    });

    /**
     * @method handleAuthorisedAbsence
     * @return {Promise<void>}
     */
    handleAuthorisedAbsence = async () => {
        this.working();

        const request = await Attendance.checkIn('last', {
            present: false,
            authorised_absence: true,
        });

        if (request.status !== 201 && request.status !== 200) {
            this.toastError('Sorry, there was a problem processing your check in');
            return;
        }

        this.toastSuccess('Your authorised absence has been registered!');
        this.props.onClose();
    };

    /**
     * @method render
     * @return {*}
     */
    render = () => {
        const {working, sick} = this.state;

        return (
            <Modal>
                <ModalHeader>
                    You have missing attendance
                </ModalHeader>

                {!sick && (
                    <ModalBody>
                        <p className="text-center">
                            There&apos;s no recorded attendance for yesterday
                        </p>

                        <div className="mt-4 flex space-x-4 justify-center">
                            <Button onClick={this.handleToggleWasSick} working={working}>
                                I was unwell
                            </Button>

                            <Button onClick={this.handleWasHere} working={working}>
                                I was here
                            </Button>

                            <Button onClick={this.handleAuthorisedAbsence} working={working}>
                                Authorised Absence
                            </Button>
                        </div>
                    </ModalBody>
                )}

                {sick && (
                    <AbsenceForm
                        onClose={this.handleToggleWasSick}
                        onComplete={this.props.onClose}/>
                )}
            </Modal>
        );
    }
}
